import { SET_CONFIRM_POPUP } from "src/action-types/popup";
import { IConfirmPopupState } from "src/reducers/popup";

const setConfirmPopup = (props: IConfirmPopupState) => ({
    props,
    type: SET_CONFIRM_POPUP,
});

export { setConfirmPopup };
